<div class="modal-container h-100">
  <div class="modal-header border-0">
    <h1 class="modal-title w-100 border-bottom">
      Send To Sourcing
    </h1>
  </div>
  <div class="modal-body">
    <div class="row mx-0">
      <div class="col-12 px-0">
      <div class="doc-tabs">
          <div class="doc-grid">
            <app-ag-grid
              id="stsRequirement"
              class="center-Pagination d-block position-relative minMaxHeightSet"
              [ngStyle]="{ height: flexHeight }"
              [dataModel]="agGridDataModelRequirement"
              (gridReady)="onReqGridReady($event)"
              (onPagination)="onReqPagination($event)"
              [footerHeight]="'footerHeight'"
              [handleCustomHeaderDisplay]="false"
              (onSelectionChange)="onReqSelectionChange($event)"
            >
            </app-ag-grid>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0 mt-5">
      <div class="col-12 px-0">
        <p class="mb-1 text-primary-color popup-secondary-text">Choose an open sourcing batch and the selected requirement(s), or create a new one.</p>  
      </div>
      <div class="col-12 px-0 pb-md-3">
        <div class="doc-tabs">
          <div class="doc-grid">
            <app-ag-grid #sourcingGrid
              class="center-Pagination d-block position-relative minMaxHeightSet"
              [ngStyle]="{ height: flexHeight }"
              [dataModel]="agGridDataModelSourcing"
              [footerHeight]="'footerHeight'"
              (gridReady)="onSourcingGridReady($event)"
              [handleCustomHeaderDisplay]="false"
              (onPagination)="onSourcingPagination($event)"
              (onSelectionChange)="onSourcingSelectionChange($event)"
            >
            </app-ag-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-end">
    <div class="d-flex justify-content-end flex-wrap m-0 gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger popup-button'"
        (click)="activeModal.close({confirm:false})" [buttonLable]="enumButtonName.CANCEL">
      </app-button>
      <app-button
        [ngClass]="{'cursor-notAllowed' : !canCreateOrAddToBatch}"
        [buttonLable]="enumButtonName.ADD_TO_SOURCING_BATCH"
        [buttonClass]="canCreateOrAddToBatch ? 'border-theme popup-button' : 'border-grey pe-none popup-button'"
        [inputReadonly]="!canCreateOrAddToBatch"
        (click)="createSourcingBatch('ADD_TO_SOURCING_BATCH')"
      ></app-button>
      <app-button
        [buttonLable]="enumButtonName.CREATE_SOURCING_BATCH"
        [buttonClass]="'border-theme popup-button'"
        (click)="createSourcingBatch('CREATE_SOURCING_BATCH')"
      ></app-button>
    </div>
  </div>
</div>
